import { render, staticRenderFns } from "./DashboardFilters.vue?vue&type=template&id=1568659a&scoped=true"
import script from "./DashboardFilters.vue?vue&type=script&lang=js"
export * from "./DashboardFilters.vue?vue&type=script&lang=js"
import style0 from "./DashboardFilters.vue?vue&type=style&index=0&id=1568659a&prod&lang=scss&scoped=true"
import style1 from "./DashboardFilters.vue?vue&type=style&index=1&id=1568659a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1568659a",
  null
  
)

export default component.exports